var VCA = VCA || {};


VCA.BreedFilters = (function ($) {

    var ui = {};

    function init() {
        bindCatFilterClick();
    }

    function bindCatFilterClick() {
        $('.js-breed-cat-filter').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                return;
            }

            $(this).closest('.js-filter-wrap').find('.active').removeClass('active');
            $(this).addClass('active');

            var catValue = $('.js-breed-pet-type-filter.active').attr('data-pet-type');
            var breedValue = $('.js-breed-cat-filter.active').attr('data-breed-cat');

            if (breedValue === 'all') {
                $('.js-breed-list-item').fadeOut().promise().done(function () {
                    $('.js-breed-list-item[data-pet-type="' + catValue + '"]').fadeIn();
                });
            } else {

                $('.js-breed-list-item').fadeOut().promise().done(function () {
                    $('.js-breed-list-item[data-pet-type="' + catValue + '"][data-breed-cat="' + breedValue + '"]').fadeIn();
                });
            }




            if ($(this).hasClass('all')) {
                $('.grid li').fadeOut().promise().done(function () {
                    $('.grid li').fadeIn();
                });
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.BreedFilters.init();
});